
import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./MainFractionationTowers.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext";
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import MDSFaceplate from "../components/MDSFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import MainFractionationLaboratory from "./MainFractionationLaboratory";

import VaporLiquidGrid from "../components/VaporLiquidGrid";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function MainFractionationTowers() {

    useEffect(() => {
    
      trackPageVisit("MainFractionationTowers");
    
    }, []);
  
     const {toggleValve, valves} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const {processData,  setProcessData} = useContext(ProcessContext);
const [showLabReport, setShowLabReport] = useState(false);


const openMainFractionationLab = () => {

    setShowLabReport(true);

};

     

  const DEFAULT_VALVES = {
  FCV_2201: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2202: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2203: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("MainFractionationTowers_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2201: { ...DEFAULT_VALVES.FCV_2201, ...parsed.FCV_2201 },
      FCV_2202: { ...DEFAULT_VALVES.FCV_2202, ...parsed.FCV_2202 },
      FCV_2203: { ...DEFAULT_VALVES.FCV_2203, ...parsed.FCV_2203 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("MainFractionationTowers_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};







const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

  
   const { transmitters, } = usePlantStore();
    const TT_15009 = transmitters.TT_15009 || 0;
    const FIC_2609 = transmitters.FIC_2609 || 0;
    const FIC_2605 = transmitters.FIC_2605 || 0;
    const TT_2602 = transmitters.TT_2602 || 0;
    const FIC_3105 = transmitters.FIC_3105 || 0;


    const TT_2304 =
  Number(
    localStorage.getItem("TT_2304")
  ) || 250;

    const FIC_2301 =
  Number(
    localStorage.getItem("FIC_2301")
  ) || 15;

    const PT_2304 =
  Number(
    localStorage.getItem("PT_2304")
  ) || 0.5;

const TT_2306 =
  Number(
    localStorage.getItem("TT_2306")
  ) || 260;

const TT_2309 =
  Number(
    localStorage.getItem("TT_2309")
  ) || 340;

const TT_24020 =
  Number(
    localStorage.getItem("TT_24020")
  ) || 32;

const TT_24010 =
  Number(
    localStorage.getItem("TT_24010")
  ) || 32;

const FIC_24010 =
  Number(
    localStorage.getItem("FIC_24010")
  ) || 0;


const FlashZoneVaporFlow =
  Number(
    localStorage.getItem(
      "FlashZoneVaporFlow"
    )
  ) || 0;

const FlashZoneVaporComposition =
  JSON.parse(
    localStorage.getItem(
      "FlashZoneVaporComposition"
    ) || "{}"
  );

  const FlashZoneLiquidComposition =
  JSON.parse(
    localStorage.getItem(
      "FlashZoneLiquidComposition"
    ) || "{}"
  );

  const OverheadComposition =
  JSON.parse(
    localStorage.getItem(
      "OverheadComposition"
    ) || "{}"
  );

  const StripperHeatingEffect =
  JSON.parse(
    localStorage.getItem(
      "StripperHeatingEffect"
    ) || "{}"
  );


  const FIC_2305 =
  Number(
    localStorage.getItem(
      "FIC_2305"
    )
  ) || 0;


  const FIC_2306 =
  Number(
    localStorage.getItem(
      "FIC_2306"
    )
  ) || 0;


  const KeroseneProduct =

  JSON.parse(
    localStorage.getItem(
      "KeroseneProduct"
    ) || "{}"
  );


localStorage.setItem(
  "KeroseneProduct",
  JSON.stringify(KeroseneProduct)
);

console.log(
  "Saving KeroseneProduct",
  KeroseneProduct
);


  const FlashZoneLiquidFlow  =

  JSON.parse(
    localStorage.getItem(
      "FlashZoneLiquidFlow"
    ) || "{}"
  );
  


  const report =
JSON.parse(
localStorage.getItem(
"MAIN_FRACTIONATION_REPORT"
)
) || {};




    const xv2201Open = !valves?.XV_2201;
    const xv2202Open = !valves?.XV_2202;
    const xv2203Open = !valves?.XV_2203;




      const FlashSeverity =
  Number(
    localStorage.getItem(
      "FlashSeverity"
    )
  ) || 0;



  
/* =========================================================
   REFLUX FLOW
========================================================= */
const FCV2201 = (valveData?.FCV_2201?.opening || 0) / 100;

const FIC_2205 = FIC_2605;

/*
More reflux =
more condensation
*/

const RefluxCooling =

  FIC_2205 * 3.0;


const TT_22061 = TT_24020;
const TT_2205 = (valveData?.FCV_2201?.opening || 0) > 0? TT_2602 : 27;

const NaphthaRefluxEffect = FIC_2205 * (TT_22061 - TT_2205) * 0.03;

/* =========================================================
   VAPORIZATION EFFECT
========================================================= */

const RefluxSuppression =

  Math.max(
    0.40,

    1 -

    (
      FIC_2205 * 0.05
    )
  );

const VaporizationEffect =

  FlashSeverity *

  FlashZoneVaporFlow *

  RefluxSuppression;

/*
Higher vaporization
raises upper tower temperature

Higher pump around
removes heat
*/



    
/* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};


  /* =========================================================
   P-107A / P-107B PUMP AROUND PUMPS
========================================================= */

const P107A_Running =
  pumpData?.["P-107A"]?.running ?? false;

const P107B_Running =
  pumpData?.["P-107B"]?.running ?? false;

const P107_Running_Count =
  (P107A_Running ? 1 : 0) +
  (P107B_Running ? 1 : 0);

const P107_Running =
  P107_Running_Count > 0;

/* =========================================================
   CONTROL VALVE
========================================================= */

const FCV2202_Opening =
  (valveData?.FCV_2202?.opening || 0) / 100;

/* =========================================================
   PUMP CAPACITY
========================================================= */

const P107_TotalCapacity =
  P107_Running_Count * 8;

/* =========================================================
   FLOW TARGET
========================================================= */

const targetFIC_22011 =
  P107_TotalCapacity * FCV2202_Opening;

/* =========================================================
   FIC-22011
========================================================= */

const FIC_22011 = processData.FIC_22011 || 0;

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_22011_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_22011 || 0);

    let next = current;

    const systemActive =
      P107A_Running ||
      P107B_Running;

    const target =
      systemActive
        ? targetFIC_22011
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    for (
      let i = 0;
      i < scans;
      i++
    ) {

      next =
        next +
        (
          target -
          next
        ) * 0.12;

    }

    return {
      ...prev,
      FIC_22011: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  targetFIC_22011,
  P107A_Running,
  P107B_Running
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_22011_LastUpdate",
    String(Date.now())
  );

}, [FIC_22011]);




useEffect(() => {

  const timer = setInterval(() => {

    setProcessData(prev => {

      const current =
        Number(prev.FIC_22011 || 0);

      const target =
        Number(targetFIC_22011 || 0);

      const next =
        current +
        (target - current) * 0.12;

      return {
        ...prev,
        FIC_22011: Number(next.toFixed(3))
      };

    });

  }, 500);

  return () => clearInterval(timer);

}, [targetFIC_22011]);

/* =========================================================
   PT-22011
========================================================= */

let PT_22011 = 0.03;

if (
  P107_Running &&
  FCV2202_Opening > 0
) {

  PT_22011 = 1.8;

  /*
    Restricted valve:
    pressure drops
  */

  if (
    FCV2202_Opening > 0 &&
    FCV2202_Opening < 0.28
  ) {

    const restrictionFactor =
      (0.28 - FCV2202_Opening) / 0.28;

    PT_22011 =
      1.8 -
      (restrictionFactor * 0.8);

  }

}

PT_22011 =
  Number(PT_22011.toFixed(3));




  

const FIC_2208 =
  xv2201Open
    ? FIC_2609
    : 0;




const FCV2203Opening =
  (
    valveData?.FCV_2203?.opening || 0
  ) / 100;

const FCV2202Opening =
  (
    valveData?.FCV_2202?.opening || 0
  ) / 100;


const FIC_2203 =

  (
    KeroseneProduct.Kerosene || 0
  ) *

  FCV2203Opening + (FIC_2205*0.3);



  /* =========================================================
   KEROSENE PRODUCT COMPOSITION
========================================================= */

const KeroseneProductTotal =

  KeroseneProduct.Kerosene +

  KeroseneProduct.Diesel;

const KeroseneProductComposition = {

  Kerosene:

    KeroseneProductTotal > 0

      ?

      FIC_2203 *

      KeroseneProduct.Kerosene /

      KeroseneProductTotal

      :

      0,

  Diesel:

    KeroseneProductTotal > 0

      ?

      FIC_2203 *

      KeroseneProduct.Diesel /

      KeroseneProductTotal

      :

      0

};

localStorage.setItem(

  "KeroseneProductComposition",

  JSON.stringify(
    KeroseneProductComposition
  )

);




  const FIC_2209 = xv2202Open ? FIC_3105/159 : 0;
  const FIC_22010 = xv2203Open ? 0.243 : 0 ;




  const RefluxCoolingEffect = FIC_2205 * (TT_2304 - TT_2205) * 0.03;
const WashWaterCoolingEffect = FIC_2208 * 1.0;
const VaporHeatingEffect = VaporizationEffect * 2.5;


  const PumpAroundLiquidInventory =

  FlashZoneLiquidFlow +

  FIC_2205 +      // reflux

  FIC_2208 +      // wash water

  FIC_2209 +      // inhibitor

  FIC_22010 -     // amine

  FIC_2203;       // kerosene withdrawal



  const LiquidCoolingEffect =

  PumpAroundLiquidInventory *
  0.6;




const TT_2201 =

  Math.max(
    120,

    (TT_2304 * 0.796) +

    VaporHeatingEffect +

    (NaphthaRefluxEffect * 0.65) -

    WashWaterCoolingEffect -

    LiquidCoolingEffect + StripperHeatingEffect
  );



/* =========================================================
   TT-22011
========================================================= */
  const atmosphericTemperature = 25;



let TT_22011 =
  atmosphericTemperature;

if (
  P107_Running &&
  FCV2202_Opening > 0
) {

  TT_22011 = TT_2201;

  /*
  Restricted valve:
  dead-heading tendency
  pump heats liquid
  */

  if (
    FCV2202_Opening > 0 &&
    FCV2202_Opening < 0.28
  ) {

    const restrictionFactor =
      (0.28 - FCV2202_Opening) /
      0.28;

    TT_22011 =
      TT_2201 +
      (
        restrictionFactor * 25
      );

  }

}

TT_22011 =
  Number(
    TT_22011.toFixed(2)
  );




// PUMP AROUND DOWNCOMER DRAW POT

const DrawPotLiquid =

  PumpAroundLiquidInventory *

  (
    0.20 +
    (1 - FlashSeverity) * 0.30
  );


const FIC_2201 = DrawPotLiquid;



  const FIC_2202 = FIC_22011 * 0.997;
  
/* =========================================================
   PUMP AROUND DRAW
========================================================= */

const PumpAroundRate =
  FIC_2201;

const PumpAroundCooling =
  PumpAroundRate *
  1.5;




const FIC_2204 = FIC_24010;



const KeroseneTrayBaseTemp =
  TT_2304 +
  (
    VaporizationEffect * 2
  ) -
  PumpAroundCooling;

/*
Valve effect:
100% open = actual tray temp

0% open = about 50% of
actual vaporization temp

No vaporization = ambient
temperature
*/

/* =========================================================
   PUMP AROUND RETURN
========================================================= */

/*
Temperature drop through
heat exchanger train
*/

const ExchangerCooling =

  25 +

  (
    PumpAroundRate * 0.8
  );

const TT_2202 = 228;

/* =========================================================
   KEROSENE DRAW TRAY
========================================================= */

/*
Located below pump around tray

More vaporization pushes
hotter material upward
*/

const KeroseneFeed =

  (
    FlashZoneVaporComposition
      ?.Kerosene || 0
  ) +

  (
    FlashZoneLiquidComposition
      ?.Kerosene || 0
  );


const KeroseneVaporFraction =

  KeroseneFeed > 0

    ?

    FlashZoneVaporComposition.Kerosene /
    KeroseneFeed

    :

    0;

const TT_2203 =

  (TT_2201 * 0.92) +

  (
    KeroseneVaporFraction * 25
  ) -

  (
    PumpAroundCooling * 0.25
  );

/* =========================================================
   KEROSENE STRIPPER RETURN
========================================================= */

/*
Temporary stripper effect

Will later come from
actual stripper model
*/

const StripperSteamEffect =

  FIC_2204 * 2.0;

const TT_2204 =

  TT_24010 +

  StripperSteamEffect;

/* =========================================================
   OVERHEAD VAPOR
========================================================= */

/*
Wash water cools overhead

Corrosion inhibitor and amine
have negligible thermal effect
*/

const WashWaterCooling =

  FIC_2208 * 0.5;


  



  const TT_2206 =

  Math.max(

    40,

    (TT_2203 * 0.72) +

    (VaporizationEffect * 1.2) -

    (FIC_2205 * 2.0) -

    (WashWaterCooling) - RefluxCoolingEffect - (NaphthaRefluxEffect) - (TT_2204 * 0.019)

  );



const PT_2201 = PT_2304 - 0.02;
const PT_2203 = PT_2201 - 0.01;
const PT_2206 = Math.max(0.05, PT_2203 - 0.02); 


const RefluxFactor =

  FIC_2301 > 0

  ?

  FIC_2205 /
  FIC_2301

  :

  0;




  const TotalOverheadAvailable =

  (OverheadComposition.LightNaphtha || 0) +

  (OverheadComposition.HeavyNaphtha || 0) +

  (OverheadComposition.Kerosene || 0);

const FIC_2206 =

  Math.max(
    0,

    TotalOverheadAvailable +

    FIC_2205*0.767
  );


console.log("OVERHEAD", OverheadComposition);

console.log(
  "Light",
  OverheadComposition.LightNaphtha
);

console.log(
  "Heavy",
  OverheadComposition.HeavyNaphtha
);

console.log(
  "Kerosene",
  OverheadComposition.Kerosene
);

console.log(
  "Reflux",
  FIC_2205
);



console.log(
  "Saving KeroseneProductComposition",
  KeroseneProductComposition
);

/* =========================================================
   SAVE TEMPERATURES
========================================================= */
localStorage.setItem(
  "FIC_2206",
  FIC_2206
);
localStorage.setItem(
  "TT_2206",
  TT_2206
);

localStorage.setItem(
  "PT_2206",
  PT_2206
);

localStorage.setItem(
  "TT_2201",
  TT_2201
);

localStorage.setItem(
  "TT_2202",
  TT_2202
);

localStorage.setItem(
  "TT_2203",
  TT_2203
);

localStorage.setItem(
  "PT_2203",
  PT_2203
);

localStorage.setItem(
  "FIC_2203",
  FIC_2203
);

localStorage.setItem(
  "TT_2204",
  TT_2204
);

localStorage.setItem(
  "TT_2205",
  TT_2205
);

localStorage.setItem(
  "TT_2206",
  TT_2206
);

localStorage.setItem(
  "FIC_2204",
  FIC_2204
);

localStorage.setItem(
  "FIC_2205",
  FIC_2205
);

localStorage.setItem(
  "TT_2205",
  TT_2205
);

localStorage.setItem(
  "FCV2201",
  FCV2201
);




useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.TT_22011 === TT_22011 &&
    current.FIC_22011 === FIC_22011 && 
    current.PT_22011 === PT_22011 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      TT_22011, FIC_22011, PT_22011 
    }
  });

}, [TT_22011, FIC_22011, PT_22011]);




/* =========================================================
   BUILD COMPLETE MAIN FRACTIONATION REPORT
========================================================= */

const BottomReport =
    JSON.parse(
        localStorage.getItem(
            "MAIN_FRACTIONATION_BOTTOM"
        )
    ) || {};

const MainFractionationReport = {

    generated:
        new Date().toLocaleString(),

    reportNumber:
        `MFT-${Date.now()}`,

    feed:
        BottomReport.feed || {},

    operation:
        BottomReport.operation || {},

    flashZone:
        BottomReport.flashZone || {},

    tower: {

        top: {

            temperature: TT_2206,
            pressure: PT_2206

        },

        upperSection: {

            temperature: TT_2203,
            pressure: PT_2203

        },

        middle: {

            temperature: TT_2304,
            pressure: PT_2304

        },

        flashZone:
            BottomReport.tower?.flashZone || {},

        bottom:
            BottomReport.tower?.bottom || {}

    },

    overhead: {

        flow: FIC_2206,

        composition:
            OverheadComposition

    },

    sideDraws: {

        kerosene: {

            flow: FIC_2203,

            composition:
                KeroseneProductComposition

        },

        diesel:
            BottomReport.sideDraws?.diesel || {}

    },

    bottoms:
        BottomReport.bottoms || {},

    performance: {

        ...(BottomReport.performance || {}),

        refluxFlow: FIC_2205,

        pumpAroundFlow: FIC_22011,

        overheadFlow: FIC_2206

    }

};

localStorage.setItem(
    "MAIN_FRACTIONATION_REPORT",
    JSON.stringify(
        MainFractionationReport
    )
);






  return (
    <div className="MainFractionationTowers-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 303px",
          zIndex: 10,
        }}
      >
        FRACTIONATION TOWER (TOP)
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}



      {/* XV-2201 */}
      <Valve
        className="XV-2201"
        tag="XV_2201"
        x={225}
        y={94}
        isClosed={valves.XV_2201}
        toggle={toggleValve}
      />

      {/* XV-2202 */}
      <Valve
        className="XV-2202"
        tag="XV_2202"
        x={225}
        y={138}
        isClosed={valves.XV_2202}
        toggle={toggleValve}
      />

      {/* XV-2203 */}
      <Valve
        className="XV-2203"
        tag="XV_2203"
        x={225}
        y={183}
        isClosed={valves.XV_2203}
        toggle={toggleValve}
      />

  



        <button
          onClick={openMainFractionationLab}
          style={{
              position: "absolute",
              right: "950px",
              top: "300px",
              padding: "8px 16px",
              background: "#0b5ed7",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "bold",
              zIndex: 500
          }}
      >
          🧪 Main Tower Report
      </button>


      {
        showLabReport && (
        <MainFractionationLaboratory
            onClose={() => setShowLabReport(false)}
        />
        )
        }





      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2201 */}
        <div
            style={{ position: "absolute", left: 940, top: 199}}
            onMouseEnter={() => setHoveredValve("FCV_2201")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2201")}
          >

            {hoveredValve === "FCV_2201" && (
              <div style={tagStyle}>
                FCV_2201
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2201">
                    
          <defs>
            <linearGradient id="metal_2201">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2201)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2201)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      

        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2202 */}
        <div
            style={{ position: "absolute", left: 310, top: 417}}
            onMouseEnter={() => setHoveredValve("FCV_2202")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2202")}
          >

            {hoveredValve === "FCV_2202" && (
              <div style={tagStyle}>
                FCV_2202
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2202">
                    
          <defs>
            <linearGradient id="metal_2202">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2202)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2202)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-2203 */}
        <div
            style={{ position: "absolute", left: 940, top: 333}}
            onMouseEnter={() => setHoveredValve("FCV_2203")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_2203")}
          >

            {hoveredValve === "FCV_2203" && (
              <div style={tagStyle}>
                FCV_2203
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-2203">
                    
          <defs>
            <linearGradient id="metal_2203">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_2203)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_2203)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      



     
       

        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}



 {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_2201?.opening || 0)}
        x={961}
        y={248}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2202?.opening || 0)}
        x={332}
        y={466}      
      />

      <ValveOutput
        value={Number(valveData?.FCV_2203?.opening || 0)}
        x={961}
        y={379}      
      />





        <Transmitter
          tag="FIC_22011"
          value={[FIC_22011]}
          x={1032}
          y={533}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PUMP AROUND DRAW FROM DISTILLATION TOWER TO HEAT EXCHANGERS"
         />

        <Transmitter
          tag="TT_2201"
          value={[TT_2201]}
          x={762}
          y={523}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF PUMP AROUND DRAW FROM DISTILLATION TOWER TO HEAT EXCHANGERS"
         />

        <Transmitter
          tag="TT_22011"
          value={[TT_22011]}
          x={942}
          y={673}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF PUMP AROUND DRAW FROM DISTILLATION TOWER TO HEAT EXCHANGERS"
         />

        <Transmitter
          tag="PT_22011"
          value={[PT_22011]}
          x={812}
          y={693}
          unit="MPa"
          max={3}
          HH={2.8}
          H={1.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF PUMP AROUND DRAW FROM DISTILLATION TOWER TO HEAT EXCHANGERS"
         />

        <Transmitter
          tag="TT_2202"
          value={[TT_2202]}
          x={442}
          y={413}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF PUMP AROUND RETURN FROM HEAT EXCHANGERS (E-108A/B) TO T-102"
         />

         <Transmitter
          tag="FIC_2202"
          value={[FIC_2202]}
          x={182}
          y={413}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PUMP AROUND RETURN FROM HEAT EXCHANGERS (E-108A/B) TO T-102"
         />

        <Transmitter
          tag="TT_2203"
          value={[TT_2203]}
          x={742}
          y={333}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF KEROSENE DRAW FROM DISTILLATION TOWER (T-102) TO KERESONE STRIPPER"
         />

         <Transmitter
          tag="PT_2203"
          value={[PT_2203]}
          x={832}
          y={333}
          unit="MPa"
          max={3}
          HH={2.8}
          H={1.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF KEROSENE DRAW FROM DISTILLATION TOWER (T-102) TO KERESONE STRIPPER"
         />

         <Transmitter
          tag="FIC_2203"
          value={[FIC_2203]}
          x={1032}
          y={333}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF KEROSENE DRAW FROM DISTILLATION TOWER (T-102) TO KERESONE STRIPPER"
         />

        <Transmitter
          tag="TT_2204"
          value={[TT_2204]}
          x={782}
          y={253}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF KEROSENE GAS RETURN FROM KERESONE STRIPPER TO DISTILLATION TOWER (T-102)"
         />

         <Transmitter
          tag="FIC_2204"
          value={[FIC_2204]}
          x={1062}
          y={253}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF KEROSENE GAS RETURN FROM KERESONE STRIPPER TO DISTILLATION TOWER (T-102)"
         />

        <Transmitter
          tag="TT_2205"
          value={[TT_2205]}
          x={782}
          y={196}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF NAPHTHA REFLUX FROM FROM REFLUX DRUM TO DISTILLATION TOWER (T-102)"
         />

         <Transmitter
          tag="FIC_2205"
          value={[FIC_2205]}
          x={1062}
          y={196}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF NAPHTHA REFLUX FROM FROM REFLUX DRUM TO DISTILLATION TOWER (T-102)"
         />

        <Transmitter
          tag="TT_2206"
          value={[TT_2206]}
          x={782}
          y={74}
          unit="°C"
          max={600}
          HH={580}
          H={555}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF OVERHEAD VAPOR FROM DISTILLATION TOWER (T-102) TO NAPHTHA REFLUX COOLER AND REFLUX DRUM DISTILLATION TOWER (T-102)"
         />

         <Transmitter
          tag="PT_2206"
          value={[PT_2206]}
          x={882}
          y={74}
          unit="MPa"
          max={3}
          HH={2.8}
          H={1.5}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF OVERHEAD VAPOR FROM DISTILLATION TOWER (T-102) TO NAPHTHA REFLUX COOLER AND REFLUX DRUM DISTILLATION TOWER (T-102)"
         />

         <Transmitter
          tag="FIC_2206"
          value={[FIC_2206]}
          x={982}
          y={74}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF OVERHEAD VAPOR FROM DISTILLATION TOWER (T-102) TO NAPHTHA REFLUX COOLER AND REFLUX DRUM DISTILLATION TOWER (T-102)"
         />

         <Transmitter
          tag="FIC_2208"
          value={[FIC_2208]}
          x={382}
          y={84}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF WASH WATER FROM WATER INJECTION PUMPS (P-110A/B) TO OVERHEAD LINE OF DISTILLATION TOWER (T-102)"
         />

         <Transmitter
          tag="FIC_2209"
          value={[FIC_2209]}
          x={136}
          y={128}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CORROSION INHIBITOR FROM CORROSION INHIBITION HEADER TO OVERHEAD LINE OF DISTILLATION TOWER (T-102)"
         />

         <Transmitter
          tag="FIC_22010"
          value={[FIC_22010]}
          x={322}
          y={188}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CORROSION INHIBITOR FROM CORROSION INHIBITION HEADER TO OVERHEAD LINE OF DISTILLATION TOWER (T-102)"
         />




            <LevelTransmitterIndicator
              tag="LT_2201"
              totalLevel={200}
              inflows={[FIC_2201]}
              outflows={[FIC_22011]}
              responseFactor={0.05}
              columnX={606}
              columnY={475}
              columnWidth={65}
              columnHeight={24}
              textX={516}
              textY={470}
              showFlow={true}
              backgroundOpacity={0.00}
              liquidOpacity={0.5}
              service="crude"
            />


            <Pump
              tag="P-107A"
              x={699}
              y={650}
              rpm={1800}
              bladeCount={pumpData?.["P-107A"]?.bladeCount || 3}
              size={pumpData?.["P-107A"]?.size || 45}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-107B"
              x={699}
              y={740}
              rpm={1800}
              bladeCount={pumpData?.["P-107B"]?.bladeCount || 3}
              size={pumpData?.["P-107B"]?.size || 45}
              onClick={openPumpPanel}
            />







    

    </div>
  );
}

export default MainFractionationTowers;
